import { render, staticRenderFns } from "./Holding.vue?vue&type=template&id=7ab9904a&"
import script from "./Holding.vue?vue&type=script&lang=js&"
export * from "./Holding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports